import { Component, OnInit } from '@angular/core';
import { GearsApiService } from 'src/app/services/gearsapi.service';
import { SitesService } from 'src/app/services/sites.service';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Component({
  selector: 'app-customerfeedback',
  templateUrl: './customerfeedback.component.html',
  styleUrls: ['./customerfeedback.component.less']
})
export class CustomerfeedbackComponent implements OnInit {
  private renderer: Renderer2;
  constructor(@Inject(DOCUMENT) private _document: Document, rendererFactory: RendererFactory2, private apiService: GearsApiService, private siteService: SitesService) { this.renderer = rendererFactory.createRenderer(null, null);}
  selind: number = 0;
  selected: any = {};
  site: any;
  reviews: any[] = [];
  ngOnInit(): void {

    this.siteService.get().then((x: any) => {
      this.site = x;
      this.apiService.get('Feedback', {
        SiteID_FK: this.site.SiteID_PK
      }).then((x: any) => {
        this.reviews = x.body;
        this.selected = this.reviews[0];
        this.loadReviewSchema();
      });
    });
  }

  next() {
    if (!(this.selind == (this.reviews.length - 1))) {
      this.selind++;
      this.selected = this.reviews[this.selind];
      this.loadReviewSchema();
    }
    else{
      this.selind = 0;
    }
  }
  prev() {
    if (!(this.selind == 0)) {
      this.selind--;
      this.selected = this.reviews[this.selind];
      this.loadReviewSchema();
    }
    else{
      this.selind = (this.reviews.length - 1);
    }
  }

  loadReviewSchema() {
    if (this._document.getElementById('ReviewSchema')) {
      this._document.querySelectorAll('[id=ReviewSchema]').forEach((element) => {
        this.renderer.removeChild(element.parentNode, element);
      });
    }
    var script   = document.createElement("script");
    script.type  = "application/ld+json";
    script.id = 'ReviewSchema';
    script.text  = `
    {
      "@context": "https://schema.org",
      "@type": "Review",
      "author": {
      "@type": "Person",
      "name": "${this.selected.Author}"
      },
      "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
      },
      "reviewBody": "${this.selected.FeedbackL}"
    }`;
    document.head.appendChild(script);
  }
}
